import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { EzidebitMethodPageRoutingModule } from './ezidebit-method-routing.module';
import { EzidebitMethodPage } from './ezidebit-method.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';
import { EzidebitAchPageModule } from '../ezidebit-ach/ezidebit-ach.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    EzidebitMethodPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    EzidebitAchPageModule,
    TranslateModule,
  ],
  declarations: [EzidebitMethodPage],
})
export class EzidebitMethodPageModule {}
